import _ from 'lodash';
import Device from '../Device';

const questions = [
  {
    model: 'sinope',
    name: 'sinope',
    type: 'oauth',
    label: 'step3OauthDeviceSinope',
    showNext: false,
    included: true,
    required: true,
    update: values => ({
      additionalFields: {
        type: 'gravity',
        mfg: 'sinope',
        tags: JSON.stringify(_.get(values, 'tags') || {}),
      },
    }),
  },
];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context, {
    modalOpts: {
      headline: 'modalDelay.headline',
      introduction: 'modalDelay.introduction',
      button: 'modalDelay.button',
    },
  });
  return promise;
};

const Sinope = new Device('sinope', { mfg: 'sinope', questions, addDevice });

export default Sinope;
